"use client";
import React, { useState } from "react";
import "./timeline.css";

const initExperiences = [
  {
    id: 1,
    image: "companies/infinitibit.png",
    company: "Infinitibit GmbH",
    date: "Feb 2026 - Present",
    role: "Rust Developer",
    description:
      "Key contributor to Graphbit, an open-source Rust agentic AI framework, and its Enterprise Edition. Building the vector database and MCP/HITL integrations.",
    active: true,
  },
  {
    id: 2,
    image: "companies/turing.png",
    company: "Turing (Client: Anthropic)",
    date: "Sep 2025 - Dec 2025",
    role: "Rust Engineer, LLM Code Training (Contractual)",
    description:
      "Authored reference-grade Rust solutions and evaluated model-generated Rust at volume to help train frontier AI models.",
    active: false,
  },
  {
    id: 3,
    image: "companies/jbc.jpeg",
    company: "JB Connect Ltd.",
    date: "Feb 2025 - Jan 2026",
    role: "Software Engineer (Lead Backend)",
    description:
      "Led backend development of a secure, performant multi-source POS analytics platform and a hierarchical point distribution system built on AWS Amplify Gen 2.",
    active: false,
  },
  {
    id: 4,
    image: "companies/bondstein.jpeg",
    company: "Bondstein Technologies",
    date: "Jan 2024 - Jan 2025",
    role: "Software Engineer (Full Stack)",
    description:
      "Frontend developer across 8+ products including Track My Vehicle and the award-winning SmartBox Solution; frontend architect for enterprise systems like the KDS port management and YBX inventory platforms.",
    active: false,
  },
  {
    id: 5,
    image: "companies/alphacue.jpeg",

    company: "AlphaCue Technologies",
    date: "Mar 2022 - Dec 2023",
    role: "Software Engineer",
    description:
      "Develop International Project and Deliver high quality & performant software",
    active: false,
  },
  {
    id: 6,
    image: "companies/ajax.jpeg",
    company: "Ajax Business Solutions",
    date: "Feb 2022 - Mar 2022",
    role: "Full Stack Developer Intern",
    description: "Contribute modules for Finance & Banking software",
    active: false,
  },
];

const Timeline = () => {
  const [experiences, setExperiences] = useState(initExperiences);
  return (
    <>
      <div className="hidden md:block">
        <div className="timeline-container text-left ">
          <div className="timeline-line"></div>
          {experiences.map((exp, index) => (
            <div
              onClick={() => {
                setExperiences((prev) =>
                  prev.map((item) => ({
                    ...item,
                    active: item.id === exp.id ? true : false,
                  }))
                );
              }}
              key={index}
              className={`timeline-item ${
                index % 2 === 0 ? "left" : "right"
              } pointer-events-auto group hover:blur-none`}
            >
              <div
                className={`absolute z-[101] ${
                  index % 2 ? "-left-[16px]" : "-right-[16px]"
                } top-[50%] -translate-y-[50%]`}
              >
                <img
                  src={exp.image}
                  style={{
                    filter: exp.active
                      ? "blur(0) grayscale(0)"
                      : "blur(0.5px) grayscale(100%)",
                  }}
                  className="h-8 w-8 rounded-full border-2 border-indigo-600 object-cover "
                  alt=""
                />
              </div>
              <div
                className={`timeline-content ${
                  index % 2 ? "ml-2" : "mr-2"
                } p-4`}
              >
                <div className="font-bold text-lg text-blue-500">
                  {exp.company}
                </div>
                <div className="font-medium text-md mt-1 text-white/90">
                  {exp.role}
                  <br />
                  <span className="timeline-date text-[10px] italic text-gray-500">
                    {exp.date}
                  </span>
                </div>

                <p>
                  <span className="text-gray-400 group-hover:text-gray-200 text-[15px] leading-none">
                    {exp.description}
                  </span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col gap-6 md:hidden mt-8 mb-8">
        {experiences.map((exp, index) => (
          <div
            onClick={() => {
              setExperiences((prev) =>
                prev.map((item) => ({
                  ...item,
                  active: item.id === exp.id ? true : false,
                }))
              );
            }}
            key={index}
            className={`relative pointer-events-auto group hover:blur-none bg-black border-blue-500 border-2 mx-2`}
          >
            <div
              className={`absolute z-[101] -top-4 left-1/2 -translate-x-1/2`}
            >
              <img
                src={exp.image}
                className="h-8 w-8 rounded-full border-2 border-indigo-600 object-cover "
                alt=""
              />
            </div>
            <div className={`p-4`}>
              <div className="font-bold text-lg text-blue-500">
                {exp.company}
              </div>
              <div className="font-medium text-md mt-1 text-white/90">
                {exp.role}
                <br />
                <span className=" text-[13px] italic text-gray-500">
                  {exp.date}
                </span>
              </div>

              <p>
                <span className="text-gray-400 group-hover:text-gray-200 text-[15px] leading-none">
                  {exp.description}
                </span>
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Timeline;
